module.exports = __webpack_public_path__ + "static/media/Passport.ccf51a89.svg";